import { EProgramTypes } from '@ucheba/utils/types/program'

export const isCoursesCheck = (programType: number): boolean => {
  return (
    programType === EProgramTypes.course ||
    programType === EProgramTypes.course1 ||
    programType === EProgramTypes.course2 ||
    programType === EProgramTypes.course3 ||
    programType === EProgramTypes.prepare ||
    programType === EProgramTypes.prepareOlimp ||
    programType === EProgramTypes.prepareSchool ||
    programType === EProgramTypes.prepareCollage ||
    programType === EProgramTypes.prepareEGE ||
    programType === EProgramTypes.prepareMaster ||
    programType === EProgramTypes.prepareOGE ||
    programType === EProgramTypes.prepareMBA ||
    programType === EProgramTypes.prepareVUZ ||
    programType === EProgramTypes.middle ||
    programType === EProgramTypes.middleKind ||
    programType === EProgramTypes.middleHS ||
    programType === EProgramTypes.middleMS ||
    programType === EProgramTypes.middleNS ||
    programType === EProgramTypes.mba ||
    programType === EProgramTypes.mbaMini ||
    programType === EProgramTypes.mbaExecutive ||
    programType === EProgramTypes.mbaSpec ||
    programType === EProgramTypes.mbaGeneral ||
    programType === EProgramTypes.mpa ||
    programType === EProgramTypes.dba ||
    programType === EProgramTypes.bba ||
    programType === EProgramTypes.event ||
    programType === EProgramTypes.event1 ||
    programType === EProgramTypes.event2 ||
    programType === EProgramTypes.event3 ||
    programType === EProgramTypes.event4 ||
    programType === EProgramTypes.event5
  )
}
